module.exports = __webpack_public_path__ + "img/vt-01.555cc99a.svg";